import React, { useContext, useEffect, useRef, useState } from "react";
import { getSetting } from "../../../../utils/frontendSettingsManager";
import HideSomeInfo from "../../../elements/hideSomeInfo/HideSomeInfo";
import MaterialPagination from "../../../styles/materialPagination";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../../../App";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

import { StyledUserBalancesWrapper } from "../../styledAccount";
import Notification from "../../../elements/notification/Notification";
import BalancesList from "../../../elements/balances/BalancesList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import BalancesFilter from "./BalancesFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import { frontendSettings, HTTP_STATUSES } from "../../../../utils/consts";
import { useTranslation } from "react-i18next";

const UserBalancesContainer = () => {
  const { user } = useContext(AppContext);

  const { t } = useTranslation("accountPage");

  const [balances, setBalances] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [hideZeroBalances, setHideZeroBalances] = useState(getSetting(frontendSettings.hideZeroClientBalances) ?? false);
  const hideZeroBalancesRef = useRef();
  hideZeroBalancesRef.current = hideZeroBalances;

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "currentTab": checkFilterItem(history, "currentTab", "user-balances", false, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currency.asset": checkFilterItem(history, "currency.asset", null),
    "service.name": checkFilterItem(history, "service.name", null),
    "amount[gte]": checkFilterItem(history, "amount[gte]", null, true),
    "amount[lte]": checkFilterItem(history, "amount[lte]", null, true)
  });

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    if (!filterData.itemsPerPage) {
      filterUrl += "&itemsPerPage=10";
    }

    if (hideZeroBalancesRef.current) {
      filterUrl += `&${frontendSettings.hideZeroBalances}=true`;
    }

    axios.get("/api/balances" + filterUrl + "&enable=true", userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setBalances(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  }, [filterData, hideZeroBalances]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  // useEffect(() => {
  //   if (balances) {
  //     // TODO Add pusher
  //   }
  // });
  //
  // const updateBalance = (message) => {
  //   const data = JSON.parse(message.data);
  //   const index = balances.findIndex(item => item.id === data.id);
  //   if (index >= 0) {
  //     balances[index].diff = `${data.amount > balances[index].amount ? "+" : ""}${data.amount -
  //     balances[index].amount}`;
  //     balances[index].amount = data.amount;
  //     let newArr = [];
  //     setBalances([
  //       ...balances,
  //       ...newArr
  //     ]);
  //   }
  // };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledUserBalancesWrapper>
        <div className="user-balances-head">
          <BalancesFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
          <HideSomeInfo
            data={hideZeroBalances}
            setData={setHideZeroBalances}
            name={frontendSettings.hideZeroClientBalances}
            label={t("balances.filter.hideZeroBalances")}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        {/*<BalanceNotificationButton*/}
        {/*  notification={notification}*/}
        {/*  setNotification={setNotification}*/}
        {/*  userId={user.userId}*/}
        {/*/>*/}
        <BalancesList
          balances={balances}
          setBalances={setBalances}
        />
        {totalPageCount > 1  &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
      </StyledUserBalancesWrapper>
    </>
  );
};

export default UserBalancesContainer;